import React, { useMemo, useState } from 'react'
import type { Item } from './Sidebar'
import { useAppTranslations } from '../../../utils/hooks/useAppTranslations'
import MenuWithIcon from '../MenuWithIcon'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Status } from '../../../__generated__/graphql'
import { FormDialog } from '../FormDialog'
import { Add } from '@mui/icons-material'
import { CreatePositionWizzardFromSidebar } from '../../../pages/position/createPosition/CreatePositionWizzard'

export const SidebarPublisherActions: React.FC<{
  item: Item
  updateSidebarItems: () => void
}> = ({ item, updateSidebarItems }) => {
  const t = useAppTranslations()
  const [createPositionDialogOpened, setCreatePositionDialogOpened] = useState(false)

  const actionsItems = useMemo(() => {
    if (item.status === Status.Archived) return []

    return [
      {
        text: t('layout.sidebar.publisher.createPosition'),
        icon: <Add fontSize="small" />,
        action: () => setCreatePositionDialogOpened(true),
        autoClose: true,
      },
    ]
  }, [item, t])

  return (
    <>
      <MenuWithIcon
        actionItems={actionsItems}
        dataId="sidebarMenuItemIcon"
        size="small"
        iconButtonSx={{ py: 0, color: 'white' }}
      >
        <MoreVertIcon fontSize="small" />
      </MenuWithIcon>
      {/* stop propagation to avoid triggering parent ListItemButton link redirection */}
      <div onClick={(e) => e.stopPropagation()}>
        <FormDialog
          title={t('position.create.title')}
          open={createPositionDialogOpened}
          setOpen={setCreatePositionDialogOpened}
        >
          <CreatePositionWizzardFromSidebar
            websiteId={item.id}
            setOpen={setCreatePositionDialogOpened}
            updateSidebarItems={updateSidebarItems}
          />
        </FormDialog>
      </div>
    </>
  )
}

export default SidebarPublisherActions
